import React, { createContext, FC, ReactNode, useContext, useMemo, useState } from "react"

interface IMigrationAccountContext {
  isMigrating?: boolean
  setIsMigrating?: React.Dispatch<React.SetStateAction<boolean | undefined>>
}

interface IProps {
  children: ReactNode
}

const defaultValues: IMigrationAccountContext = {}
export const MigrationAccountContext = createContext<IMigrationAccountContext>(defaultValues)

const MigrationAccountProvider: FC<IProps> = ({ children }) => {
  const [isMigrating, setIsMigrating] = useState<boolean | undefined>(defaultValues.isMigrating)

  const contextValue: IMigrationAccountContext = useMemo(
    () => ({
      isMigrating,
      setIsMigrating,
    }),
    [isMigrating],
  )

  return (
    <MigrationAccountContext.Provider value={contextValue}>
      {children}
    </MigrationAccountContext.Provider>
  )
}

export const useMigrationAccount = () => useContext(MigrationAccountContext)

export default MigrationAccountProvider
